import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.grey[100],
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 2.4fr 1fr 2fr',
    gap: 0,
    padding: 24,
    alignItems: 'flex-start',
    [theme.breakpoints.down(1025)]: {
      gridTemplateColumns: '0.5fr 1fr 0.7fr'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  providerCurrencyContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 5,
    paddingTop: 28
  },
  menuItemRight: {
    direction: 'ltr'
  },
  channelCurrencyContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 5,
    paddingTop: 28,
    marginLeft: 20
  },
  dateSelectorForm: {
    marginLeft: 30,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      width: '100%',
      marginTop: 25
    }
  },
  addMoreDateRangeIcon: {
    marginRight: 8
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 25,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 20
    }
  },
  searchInput: {
    marginBottom: 12
  },
  inputNumber: {
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
}))

export default useStyles
